import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CarTilesCarousel } from '../../../../../components/carousels/car-tiles/CarTilesCarousel/CarTilesCarousel';
import { IVehicleTile } from '../../../../../types/vehicleTile';
import { removeViewedVehicleItemLocalStorage } from '../../../../home/utilities/viewedVehiclesTileBuilder';
import useAppState from '../../../../../common/state/appState';

const OptViewed = () => {
    const isLoading = useAppState((state) => state.isLoading);
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const removeRecentlyViewedVehicle = useAppState((state) => state.removeRecentlyViewedVehicle);

    const onRemove = (vehicle: IVehicleTile) => {
        const { stockNumber } = vehicle;

        removeRecentlyViewedVehicle(stockNumber);

        removeViewedVehicleItemLocalStorage(vehicle);
    };

    if (isLoading || recentlyViewedVehicles.length === 0) {
        return <></>;
    }

    return (
        <Stack spacing={1}>
            <Typography variant="h5" component="h1">
                You looked at
            </Typography>
            <CarTilesCarousel
                carouselId="viewed-vehicles"
                vehiclesData={recentlyViewedVehicles}
                placeholder={{ cardText: 'Nothing feeling quite right?', buttonText: 'Browse for cars' }}
                onRemove={onRemove}
                isRemoveEnabled
                sectionName="You looked at"
                nextFocus="personal-finance-component"
            />
        </Stack>
    );
};

export default OptViewed;
